const webpackContext = require.context("./svg", false, /\.svg$/);
const requireAll = (requireContext) => {
    // requireContext.keys()  匹配的 文件路径数组
    return requireContext.keys().map(requireContext);
};
// 得到一个完整解析的module数组
requireAll(webpackContext);


/**
 *     <template>
 *   <div
 *     class="route"
 *     v-for="item in content"
 *     :key="item.id"
 *     @click="toBlog(item)"
 *   >
 *     <svg-icon :iconClass="item.iconClass" :width="item.width"></svg-icon>
 *     <div v-if="item.title">{{ item.title }}</div>
 *   </div>
 * </template>
 * <script setup>
 * const content = [
 *         { id: 1, iconClass: "home", width: "30", path: "/" },
 *         { id: 2, iconClass: "wenzhang", width: "30", path: "/blog" },
 *         { id: 3, iconClass: "ziliao", width: "30" },
 * ]
 * </script>
 *
 * 作者：秋水不爱星河
 * 链接：https://juejin.cn/post/7138302448770383880
 * 来源：稀土掘金
 * 著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
 */